import React from 'react';

interface PageHeaderProps {
    title: React.ReactNode;
    description?: string;
    badges?: React.ReactNode;
    actions?: React.ReactNode;
}

export const PageHeader = ({
    title,
    description,
    badges,
    actions
}: PageHeaderProps) => (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
            <div className="flex flex-wrap items-center gap-2">
                <h1 className="text-2xl font-semibold tracking-tight">
                    {title}
                </h1>
                {badges}
            </div>
            {description && (
                <p className="text-sm text-muted-foreground">{description}</p>
            )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
);
